__webpack_require__.p = "/apps/integration_collaboard/js/";